// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d5238ec8","787":"69c47bd4"}[chunkId] + ".chunk.js";
};